import { useEffect, useState } from 'react';

import Form from '../../../components/Form/Form';
import Spots from '../../../components/Spots/Spots';
import SpotGenerator from '../../../components/Spots/SpotGenerator';

import './CallbackPage.css';

export default function Callback() {
    const [leftSpots, setLeftSpots] = useState([]);
    const [rightSpots, setRightSpots] = useState([]);

    useEffect(() => {
        let active = true;

        Promise.all([
            SpotGenerator.generate('callback-left'),
            SpotGenerator.generate('callback-right'),
        ]).then(([left, right]) => {
            if (!active) return;
            setLeftSpots(left);
            setRightSpots(right);
        });

        return () => {
            active = false;
        };
    }, []);

    return (
        <section className='callback' id='callBack'>
            <Spots spots={leftSpots} bottom={130} left={-540} className='callback__spot callback__spot--left' aria-hidden='true' />
            <Spots spots={rightSpots} bottom={40} left={430} spotDelay={1.8} className='callback__spot callback__spot--right' aria-hidden='true' />

            <div className='callback__content'>
                <h2>Связаться с нами</h2>
                <p className='callback__call'>{'//'} Заполните форму и наш сотрудник свяжется с вами.</p>
                <div className='callback__form'><Form /></div>
            </div>
        </section>
    );
}
